import { InvoiceLogAPI } from "../api"
import { User } from "../classes"
export class InvoiceLog {
  constructor(props) {
    for (const [key, value] of Object.entries(props)) {
      if(value.className && value.className == '_User'){
        this[key] = new User(value);
      }else{
        this[key] = value;
      }
    }
  }
  static async getInvoiceLogs(invoiceId) {
    const { data } = await InvoiceLogAPI.getInvoiceLogs(invoiceId);
    return data.result.map((item) => new InvoiceLog(item)).sort((a, b) => { return new Date(b.createdAt) - new Date(a.createdAt) })
  }
}